import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastContainer } from 'react-toastify';
import { KeycloakProvider } from './KeycloakContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const eventLogger = (event, error) => {
  console.log('onKeycloakEvent', event, error);
};

const tokenLogger = (tokens) => {
  console.log('onKeycloakTokens', tokens);
};

root.render(
    <KeycloakProvider>
      <App />
      <ToastContainer />
    </KeycloakProvider>
);